import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import styles from "../../css/EditForm.module.css";

const EditProfile = () => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [skills, setSkills] = useState("");
  const [certificationFiles, setCertificationFiles] = useState([]);
  const [projectFiles, setProjectFiles] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchProfileDetails();
  }, []);

  const fetchProfileDetails = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get("https://techservicemarket-backend.onrender.com/api/users/profile", {
        headers: { Authorization: `Bearer ${token}` },
      });

      const user = response.data;
      setUsername(user.username);
      setEmail(user.email);
      setFirstName(user.firstName);
      setLastName(user.lastName);
      setSkills(user.skills?.join(", ") || ""); // Join skills array into a comma-separated string
      setCertificationFiles(user.certificationFiles || []);
      setProjectFiles(user.projectFiles || []);
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (!file) {
      console.error("No file selected");
      return;
    }

    if (type === "certification") {
      setCertificationFiles([file]); // Replace old certification file with the new one
    } else if (type === "project") {
      setProjectFiles([file]); // Replace old project file with the new one
    }
  };

  const handleUpdateProfile = async () => {
    try {
      const token = localStorage.getItem("token");

      // Prepare updated profile data
      const updatedProfile = {
        firstName,
        lastName,
        email,
        skills: skills.split(",").map((skill) => skill.trim()), // Parse skills into an array
      };

      const formData = new FormData();
      formData.append("profile", JSON.stringify(updatedProfile));

      // Append files to formData
      if (certificationFiles.length > 0) {
        formData.append("certification", certificationFiles[0]); // Only one file for certification
      }
      if (projectFiles.length > 0) {
        formData.append("project", projectFiles[0]); // Only one file for project
      }

      // Send the data to the server
      await axios.post(
        "https://techservicemarket-backend.onrender.com/api/users/profile/update",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert("Profile updated successfully");
      navigate("/profile"); // Redirect to profile page
    } catch (error) {
      console.error("Error updating profile:", error);
      alert("Failed to update profile. Please try again.");
    }
  };

  return (
    <div className={styles.jobFormContainer}>
        <div className={styles.titleRow}>
          <button className={styles.backButton} onClick={() => navigate("/profile")}>
            ← Back to Profile
          </button>
          <h2>Edit Profile</h2>
          <button onClick={handleUpdateProfile} className={styles.postButton}>
            Update Profile
          </button>
      </div>
      <div className={styles.mainContent}>
        <input
          type="text"
          placeholder="First Name"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          className={styles.inputField}
        />
        <input
          type="text"
          placeholder="Last Name"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          className={styles.inputField}
        />
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className={styles.inputField}
        />
        <input
          type="text"
          placeholder="Skills (comma-separated)"
          value={skills}
          onChange={(e) => setSkills(e.target.value)}
          className={styles.inputField}
        />
        <div className={styles.buttonRow}>
          <div className={styles.uploadSection}>
            <label htmlFor="certification-upload" className={styles.inputButton}>
              Upload Certification
            </label>
            <input
              type="file"
              id="certification-upload"
              style={{ display: "none" }}
              onChange={(e) => handleFileChange(e, "certification")}
            />
            <div>
              {certificationFiles.map((cert, index) => (
                <p key={index}>{cert.name}</p>
              ))}
            </div>
          </div>

          <div className={styles.uploadSection}>
            <label htmlFor="project-upload" className={styles.inputButton}>
              Upload Project
            </label>
            <input
              type="file"
              id="project-upload"
              style={{ display: "none" }}
              onChange={(e) => handleFileChange(e, "project")}
            />
            <div>
              {projectFiles.map((proj, index) => (
                <p key={index}>{proj.name}</p>
              ))}
            </div>
          </div>
        </div>
      </div>
      <footer className={styles.footer}>
        <p>&copy;2024 TechServiceMarket Software</p>
      </footer>
    </div>
  );
};

export default EditProfile;
